import { Controller } from '@hotwired/stimulus';
import { autoplayPermission } from '../../lib/autoplay_permission';

export default class extends Controller {
  static targets = ['media'];
  static values = { guideUrl: String };

  connect() {
    autoplayPermission.check(this.guideUrlValue);
  }

  mediaTargetConnected(media) {
    autoplayPermission.play(media, {
      guideUrl: this.guideUrlValue,
      onError: (error) => {
        console.error('[Autoplay Permission] Playback error:', error);
      }
    });
  }

  mediaTargetDisconnected(media) {
    autoplayPermission.forget(media);
  }
}
